import Push from 'push.js';
import Store from '../../Store';
import { browserNotifyAction } from '../../Actions/BrowserAction';
import IndexedDb from '../IndexedDb';
import { getAvatarImage, groupAvatar } from '../../Components/WebChat/Common/Avatarbase64';
import { getGroupData } from '../Chat/Group';
import { getCallDisplayDetailsForOnetoManyCall } from '../Call/Call';
import { getUserDetails } from '../Chat/User';
import { shouldHideNotification } from '../Utility';
import {getFromLocalStorageAndDecrypt} from '../../Components/WebChat/WebChatEncryptDecrypt';
const state = Store.getState();

const getGroupDetails = (groupId) => {
    let rosterData = {};
    let group = getGroupData(groupId);
    rosterData.displayName = group.groupName;
    rosterData.image = group.groupImage;
    rosterData.thumbImage = group.thumbImage;
    rosterData.jid = group.groupId;
    rosterData.chatType = "groupchat";
    return rosterData;
}

const browserNotify = {
    timeOut: 20000,
    isPageHidden: false,
    init: function(){
        Push.Permission.request(() => {}, () => {});
    },
    hasPermission: function(){
        const webSettings = getFromLocalStorageAndDecrypt('websettings')
        let parseredWebSettings = webSettings ? JSON.parse(webSettings) : {}
        const { Notifications = true } = parseredWebSettings;
        return Notifications && Push.Permission.has();
    },
    hasPermissionForCall: function(){
        return browserNotify.hasPermission();
    },
    isUrl: (str) => {
        return str.startsWith("http://") || str.startsWith("https://");
      },
  sendCallNotification(callDetailObj) {
    if (!browserNotify.hasPermissionForCall()) return;
    if(Store.getState().oldSession.isThisOldSession) return;
    let rosterData = {};
    let displayName = "";
    if (callDetailObj.callMode === "onetoone") {
        const user = callDetailObj.to;
        rosterData = getUserDetails(user);
        displayName = rosterData?.displayName || "";
    } 
    else { 
        if (callDetailObj.groupId) {
            const groupId = callDetailObj.groupId.includes("@")
                ? callDetailObj.groupId.split("@")[0]
                : callDetailObj.groupId;
            rosterData = getGroupDetails(groupId);
        } else {
            const userList = callDetailObj.userList.split(",");
            rosterData = getCallDisplayDetailsForOnetoManyCall(userList);
        }
        displayName = rosterData?.displayName || "";
    }
    if (!rosterData) return;
    let title = null;
    let pageName = null;
    const isGroupCall = callDetailObj.callMode === "onetomany";
    const callTypeLabel = `${isGroupCall ? "group " : ""}${callDetailObj.callType}`;
    if (callDetailObj.status === "calling") {
        pageName = "calleescreen";
        title = `Incoming ${callTypeLabel} call`;
        if (shouldHideNotification() && browserNotify.isPageHidden) {
            displayName = "New Incoming Call";
        }
    } 
    else if (callDetailObj.status === "ended") {
        pageName = "calllog";
        title = `You missed ${
            !isGroupCall && callDetailObj.callType === "audio" ? "an" : "a"
        } ${callTypeLabel} call`;

        if (shouldHideNotification() && browserNotify.isPageHidden) {
            displayName = "New Missed Call";
        }
    }
    if (!title) return;
    const notifyBody = {
        body: displayName,
        onClick() {
            window.focus();
            this.close();
            Store.dispatch(browserNotifyAction(pageName));
        }
    };
    let image = rosterData.thumbImage || rosterData.image;    
    if (!image) {
        const avatar = isGroupCall ? groupAvatar  : getAvatarImage ;
        return browserNotify.sendNotification(title, { ...notifyBody, icon: avatar });
    }
    if (browserNotify.isUrl(image)) {
        return browserNotify.sendNotification(title, { ...notifyBody, icon: image });
    }
    const localDb = new IndexedDb();
    if (Array.isArray(image)) image = image[0];
    localDb.getImageByKey(image, "profileimages")
        .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            browserNotify.sendNotification(title, { ...notifyBody, icon: blobUrl });
        })
        .catch(() => {
            const avatar = isGroupCall ?groupAvatar  : getAvatarImage ;
            browserNotify.sendNotification(title, { ...notifyBody, icon: avatar });
        });
},
    sendNotification: function(title, bodyObj = {}){
        if(!title) return;
        const webSettings = getFromLocalStorageAndDecrypt('websettings')
        let parseredWebSettings = webSettings ? JSON.parse(webSettings) : {}
        const { Sound = false } = parseredWebSettings;
        bodyObj = {...bodyObj, timeout: browserNotify.timeOut, silent:Sound, requireInteraction: true};
        Push.create(title, bodyObj);
    }
}

export default browserNotify;
